import Vue from 'vue'
import App from './App.vue'
import '@/layouts/index'
import './assets/js/rem'
import { addExtension } from '@/api/c_course.js'
import wx from 'weixin-js-sdk' // 引入微信SDK
Vue.config.productionTip = false
import { imgPath, apiShareUrl ,xyLinkUrl} from '@/config/global'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import '../rem.js'
Vue.use(VideoPlayer)
require('vue-video-player/src/custom-theme.css')
Vue.prototype.imgPath = imgPath
Vue.prototype.apiShareUrl = apiShareUrl
Vue.prototype.xyLinkUrl = xyLinkUrl
Vue.prototype.isReachApp = false
import router from './router/index'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { analysisUrl, locationReplace } from '@/utils/public.js'
import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// export default vConsole
import bridge from '@/utils/app_dsbridge'
import cookie from '@/utils/globalData.js'

Vue.prototype.$bus = new Vue()
Vue.prototype.isShowView = false
if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
  window.entryUrl = location.href.split('#')[0]
}
router.beforeEach(async (to, from, next) => {
  console.log(to, from, '地址')

  wx.hideAllNonBaseMenuItem()
  // 需要限制登录处理
  if (to.path == '/index') {
    bridge.call('showHead', { status: 0 })
    let Btoken = bridge.call('getToken', '获取app的token值')
    window.localStorage.setItem('token', Btoken)
    let data = await cookie.checkIsOpen()
    if (data) {
      next('/open')
    }
  } else if (to.path == '/details' || to.path == '/video') {
    bridge.call('showHead', { status: 0 })
  }
  console.log(to.fullPath,'====222')
  var obj = analysisUrl(to.fullPath)
  console.log(obj,'====111')
  if (obj.token && Object.keys(obj).length >= 1) {
    let b = ''
    let obj = {
      ...to.query,
      time: Math.random()
    }
    for (let i in obj) {
      if (i != 'token') b += '&' + i + '=' + obj[i]
    }
    let reg = new RegExp('&')
    b = b.replace(reg, '')
    localStorage.setItem('token', obj.token)
    localStorage.setItem('isReach', 1)
    if (Object.keys(obj).length >= 2) {
      next({ path: `${to.path}?${b}`, replace: true })
    } else {
      next({ path: `${to.path}`, replace: true })
    }
    return
  }

  if (obj._user_id) {
    localStorage.setItem('c_userId', obj._user_id)
  }
  if (obj.type == 'share') {
    localStorage.setItem('b_userId', obj.extension_store_id)
    console.log(obj)
    // 添加分享关系
    addExtension({
      extension_user_id: obj.extension_uid,
      extension_store_id: obj.extension_store_id,
      extend_id: obj.article_id,
      type: obj.tShare
    }).then(e => {
      console.log(e, '分享关系')
      if (e.status == 200) {
        localStorage.setItem('extension_id', e.content.extension_id)
      }
    })
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// 写入 main.js 中即可
document.addEventListener("WeixinJSBridgeReady",
   function onBridgeReady() {
     // 通过下面这个API隐藏右上角按钮
     WeixinJSBridge.call("hideOptionMenu");
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
